import { PlayyardRain } from "./PlayyardRain";
import { Column } from "@/components/Column";

import { PetYardWeatherCondition, PlayyardSky } from "@/types";

// Haze that softens the far hills while it's coming down.
const RAIN_HAZE_OPACITY: Partial<Record<PetYardWeatherCondition, number>> = {
  [PetYardWeatherCondition.DRIZZLE]: 0.18,
  [PetYardWeatherCondition.RAIN]: 0.3,
  [PetYardWeatherCondition.THUNDERSTORM]: 0.38,
};

// Precipitation, fog and haze over the yard; the pets stay clickable
// underneath because every layer ignores pointer events.
export const PlayyardWeatherLayer = ({ sky }: { sky: PlayyardSky }) => {
  const hazeOpacity = RAIN_HAZE_OPACITY[sky.condition];

  return (
    <Column className="pointer-events-none absolute inset-0 z-40 overflow-hidden">
      {hazeOpacity ? (
        <Column
          className="absolute inset-x-0 top-0 h-[75%] bg-gradient-to-b from-transparent via-slate-300 to-transparent"
          style={{ opacity: hazeOpacity }}
        />
      ) : null}
      {sky.condition === PetYardWeatherCondition.DRIZZLE ||
      sky.condition === PetYardWeatherCondition.RAIN ||
      sky.condition === PetYardWeatherCondition.THUNDERSTORM ? (
        <PlayyardRain
          condition={sky.condition}
          isWindy={sky.isWindy}
          nightAmount={sky.nightAmount}
        />
      ) : null}
      {sky.condition === PetYardWeatherCondition.SNOW ? (
        <Column className="staffer-pet-yard-snow absolute inset-0" />
      ) : null}
      {sky.condition === PetYardWeatherCondition.FOG ? (
        <PlayyardFogBanks />
      ) : null}
    </Column>
  );
};

const PlayyardFogBanks = () => {
  return (
    <>
      <Column className="staffer-pet-yard-fog absolute inset-x-[-10%] top-[34%] h-[26%] rounded-[50%] bg-white/55 blur-2xl" />
      <Column className="staffer-pet-yard-fog absolute inset-x-[-10%] top-[50%] h-[22%] rounded-[50%] bg-white/40 blur-2xl [animation-delay:-9s]" />
      <Column className="absolute inset-0 bg-white/15" />
    </>
  );
};
